module.exports = __webpack_public_path__ + "img/theater_round_15.ab18dfaa.png";